var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2665_2152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 2.66617H4.53301C3.4129 2.66617 2.85285 2.66617 2.42503 2.88415C2.0487 3.0759 1.74274 3.38186 1.55099 3.75819C1.33301 4.18601 1.33301 4.74606 1.33301 5.86617V11.4662C1.33301 12.5863 1.33301 13.1463 1.55099 13.5741C1.74274 13.9505 2.0487 14.2564 2.42503 14.4482C2.85285 14.6662 3.4129 14.6662 4.53301 14.6662H10.133C11.2531 14.6662 11.8132 14.6662 12.241 14.4482C12.6173 14.2564 12.9233 13.9505 13.115 13.5741C13.333 13.1463 13.333 12.5863 13.333 11.4662V8.66617M5.33299 10.6662H6.44935C6.77547 10.6662 6.93853 10.6662 7.09198 10.6293C7.22803 10.5967 7.35809 10.5428 7.47739 10.4697C7.61194 10.3872 7.72724 10.2719 7.95785 10.0413L14.333 3.66617C14.8853 3.11388 14.8853 2.21845 14.333 1.66617C13.7807 1.11388 12.8853 1.11388 12.333 1.66617L5.95783 8.04133C5.72723 8.27193 5.61193 8.38723 5.52947 8.52179C5.45637 8.64108 5.40249 8.77114 5.36983 8.90719C5.33299 9.06064 5.33299 9.2237 5.33299 9.54982V10.6662Z",
    stroke: "#48897F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2665_2152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGreen);
export default __webpack_public_path__ + "static/media/edit-icon-green.7cc3cd2a799fd18e361cabf1245826a6.svg";
export { ForwardRef as ReactComponent };